import React, { useState } from 'react';
import styled from '@emotion/styled';
import colours from '~/utils/colours';
import Color from 'color';

export interface InputProps {
  value?: string;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const Wrapper = styled.div`
  display: flex;
  position: relative;
  border: 2px solid ${colours.greyLightAlt7};
  border-radius: 5px;
  width: 100%;
  padding: 0 10px;
  align-items: center;

  &:focus-within {
    border: 2px solid ${() => Color(colours.greyLightAlt7).darken(0.5)};
  }
`;

const TextInput = styled.input`
  height: 40px;
  line-height: 40px;
  margin-right: 10px;
  padding: 10px 0;
  width: 100%;
  border: none;
  outline: none;

  color: ${() => Color(colours.greyLightAlt7).darken(0.5)};

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${colours.greyDarkAlt6};
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${colours.greyDarkAlt6};
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${colours.greyDarkAlt6};
  }
`;

const Input = ({ value, onChange }: InputProps) => {
  const [inputValue, setInputValue] = useState<string>(value || '');
  const onInputChange = (e: React.FormEvent<HTMLInputElement>) => {
    setInputValue(e.currentTarget.value);
    onChange(e);
  };

  return (
    <Wrapper>
      <TextInput
        type='text'
        value={inputValue}
        placeholder='Paste a link to be embedded'
        onChange={onInputChange}
      />
    </Wrapper>
  );
};

export default Input;
